// @flow

import * as React from 'react';

import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { selectCartUUID } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectSearchValue } from '../../DomainCreate/modules/selectors/search';
import type { ExtendedSuggestion } from '../../DomainCreate/types';

import DomainIntro from './DomainIntro';

import DomainSearch from './DomainSearch';

import styles from './Domains.scss';

export type OwnProps = {
  childRef: React.ElementRef<any>,
  application?: ApplicationSummary,
  handleChooseDomain: (value: ExtendedSuggestion) => Promise<void>,
};

export type Props = {
  ...OwnProps,
};

export function Domains({
  childRef,
  application,
  handleChooseDomain,
}: Props): React.MixedElement {
  return (
    <div
      className={styles.whDomainsContainer}
      ref={childRef}
      id="choose-a-domain"
    >
      <Base marginBottom="base">
        <DomainIntro application={application} />
      </Base>

      <Base marginBottom="base">
        <DomainSearch handleChooseDomain={handleChooseDomain} />
      </Base>

      <SkipDomain />
    </div>
  );
}

function SkipDomain() {
  const { __ } = useTranslator();
  const navigate = useNavigate();

  const cartId = useAppSelector(selectCartUUID);
  const search = useAppSelector(selectSearchValue);

  if (!cartId || search) {
    return null;
  }

  return (
    <Base className={clsx(styles.continue, 'wrapper-md')}>
      <Base
        backgroundColor="surface"
        bordered
        borderColor="grey-light"
        borderRadius="2x"
        flex
        flexColToRow
        flexJustifyBetween
      >
        <Base flex flexCol gap="xxsmall">
          <Base margin="none" size="big" tagName="p" weight="semibold">
            {__('Do you already have a domain name?')}
          </Base>
          <Base margin="none" tagName="p">
            {__(
              'You can use one of your existing domains managed by Gandi or another registrar. The configuration will take place after the purchase.',
            )}
          </Base>
        </Base>
        <Base flexGrow1>
          <Button
            iconAfter="arrowRight"
            onClick={() => navigate(`/cart/${cartId}/overview`)}
            type="button"
          >
            {__('Skip')}
          </Button>
        </Base>
      </Base>
    </Base>
  );
}
